import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar } from '@/components';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Username } from '@/components/shared/username';
import { ProfilePrivateDto } from '@/store/services/MidleNestApi.service';
import classNames from 'classnames';

interface Props {
  profile?: ProfilePrivateDto;
  className: string;
  isRewardAvailable?: boolean;
}

export default function AuthInfo({ profile, isRewardAvailable = false, className = '' }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleProfile = useCallback(() => {
    navigate('/profile');
  }, []);

  const location = useLocation();

  return (
    <div className='flex items-center space-x-4'>
      {isRewardAvailable && (
        <button
          type='button'
          className='px-4 py-2 text-xs whitespace-nowrap bg-orange-200 dark:bg-transparent dark:border dark:border-[#FFDA68] dark:text-[#FFDA68] rounded-md'
          onClick={() => navigate('/daily')}
        >
          {t('Claim Reward!')}
        </button>
      )}
      <div
        className={classNames(
          'transition-all border-b-2 flex items-center cursor-pointer py-1.5',
          className,
          location.pathname.match(/profile/)
            ? 'border-gray-200 dark:border-[#FFDA68]/30'
            : 'border-transparent',
        )}
        onClick={handleProfile}
      >
        <div className='flex flex-col items-end mr-2'>
          <div className='font-bold dark:text-white'>
            {t('Hi')},{' '}
            <NavLink
              className={({ isActive }) => classNames(isActive && 'text-blue-500')}
              to='/profile'
            >
              <Username>{profile?.user?.username || ''}</Username>
            </NavLink>
          </div>
          <div className='w-max flex items-center space-x-2 font-semibold'>
            <div>
              <label className='font-normal text-gray-400 dark:text-white mr-1'>
                {t('Points:')}
              </label>
              <span className='dark:text-[#FFDA68]'>{profile?.currentXp}</span>
            </div>
            <div className=''>
              <label className='font-normal text-gray-400 dark:text-white mr-1'>
                {t('Tickets:')}
              </label>
              <span className='dark:text-[#FFDA68]'>{profile?.currentTicket}</span>
            </div>
          </div>
        </div>
        <Avatar name={profile?.user?.username || ''} src={profile?.avatar?.src} />
      </div>
    </div>
  );
}
